import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./c98_programmes.scss"
import InnerHTML from 'dangerously-set-html-content';
import Slider from "react-slick";
import {replaceComponentsCachedUrl, replaceImagesCachedUrl} from "../../utils/utils";

class C98Programmes extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            btnHidden: '',
            dataIndex: null,
            disabled: false,
            slideIndex: 1,
            updateCount: 0
        };

        this.requireInternationalization = true;

        this.dataUrl = replaceComponentsCachedUrl(this.dataUrl);
    };

    internationalComponentRender(data, t) {
        data = replaceImagesCachedUrl(data);

        console.log('==================data', data)
        const sliderSettings = {
            arrows: false,
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: data.max_columns,
            slidesToScroll: 0,

            responsive: [
                {
                    breakpoint: 1810,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 5.5,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 3.5,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 2.5,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 648,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '-25px',
                    }
                }
            ]

            // beforeChange: (currIndex, nextIndex) => {
            //     // We cannot change the state, or the rerender won't let the slider component to work properly
            //     this.setState({active: nextIndex});
            // }
        };
        const cards = data.cards.map((card, index) =>
            <div className="prog-card-container" key={index}>
                <div className="prog-card" style={{ border: '3px solid' + card.color }}>
                    <img src={card.image} width="100%" alt={card.link_title+ " thumbnail"}
                        height="auto"
                    />


                </div>
                <div className="button-container">
                    <button style={{ backgroundColor: card.color, outlineColor: card.color }}><a href={card.link_url} >{card.link_title} </a></button></div>
            </div>
        )


        return (
            <div className="prog-container mb-5">
                <div className="prog-title">{data.title}</div>
                <hr />
                <div className="subtitle">
                    {data.subtitle}
                </div>
                <div className="prog-cards">
                    <Slider {...sliderSettings}>
                        {cards.map((card, index) => { return <div key={index}>{card}</div> })}
                    </Slider>

                </div>
            </div>)
    }
}

export default C98Programmes;